import React from 'react'
import { DsBox, DsStack, DsTypography } from '@am92/react-design-system'

import { T_LANDING_PAGE_CONSTANTS } from '../../Landing.PageConstants/TYPES'
import { ADULT_FEATURES, CHILD_FEATURES } from '../../LandingPage.Constants'
import { FeatureCard } from './FeatureCard'
import FeatureSelectorButton from './FeatureSelectorButton'

interface IFeaturesProps {
  PAGE_CONSTANTS: T_LANDING_PAGE_CONSTANTS
}

const Features: React.FC<IFeaturesProps> = props => {
  const { PAGE_CONSTANTS } = props

  const [selectedFeature, setSelectedFeature] = React.useState<
    'child' | 'adult'
  >('child')

  const handleFeatureChange = (feature: 'child' | 'adult') => {
    setSelectedFeature(feature)
  }

  const FEATURES = selectedFeature === 'child' ? CHILD_FEATURES : ADULT_FEATURES

  return (
    <DsBox>
      <DsStack
        direction='column'
        spacing='var(--ds-spacing-frostbite)'
        justifyContent='center'
        sx={{
          px: {
            xs: 'var(--ds-spacing-bitterCold)',
            md: 'var(--ds-spacing-hot)'
          }
        }}
      >
        <DsTypography variant='subheadingSemiboldLarge' textAlign='center'>
          {PAGE_CONSTANTS.FEATURES_KICKER}
        </DsTypography>
        <DsTypography variant='displayBoldSmall' textAlign='center'>
          {PAGE_CONSTANTS.FEATURES_TITLE}
        </DsTypography>
      </DsStack>

      <DsStack
        direction='row'
        justifyContent='center'
        sx={{
          mt: {
            xs: 'var(--ds-spacing-mild)',
            md: 'var(--ds-spacing-hot)'
          }
        }}
      >
        <DsStack
          direction='row'
          sx={{
            borderRadius: 'var(--ds-radius-frostbite)',
            overflow: 'hidden',
            width: '400px',
            maxWidth: '100%',
            mx: 'var(--ds-spacing-bitterCold)'
          }}
        >
          <FeatureSelectorButton
            label={PAGE_CONSTANTS.FEATURES_CHILD_LABEL}
            value='child'
            selectedValue={selectedFeature}
            onSelect={handleFeatureChange}
          />
          <FeatureSelectorButton
            label={PAGE_CONSTANTS.FEATURES_ADULT_LABEL}
            value='adult'
            selectedValue={selectedFeature}
            onSelect={handleFeatureChange}
          />
        </DsStack>
      </DsStack>
      <DsStack
        direction='column'
        sx={{
          px: {
            xs: 'var(--ds-spacing-bitterCold)',
            md: 'var(--ds-spacing-hot)'
          },
          mt: {
            xs: 'var(--ds-spacing-warm)',
            md: 'var(--ds-spacing-molten)'
          }
        }}
        spacing={{ xs: 'var(--ds-spacing-cool)', md: 'var(--ds-spacing-hot)' }}
      >
        {FEATURES.map((feature, index) => (
          <FeatureCard
            key={feature}
            feature={feature}
            index={index}
            PAGE_CONSTANTS={PAGE_CONSTANTS}
          />
        ))}
      </DsStack>
    </DsBox>
  )
}

export default Features
